import pathToRegexp from 'path-to-regexp';
import { ClassAttributes, createElement, FC } from 'react';
import ReactDocumentTitle from 'react-document-title';

import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement>;

const DocumentTitle: FC<Props> = () => (
  <StateConsumer>
    {(state) => {
      const location = state.location;
      let title: string | null = null;

      if (state.authentication.fetching >= 1) {
        title = 'Signing in...';
      } else if (!state.authentication.signedInUser) {
        title = 'Sign in';
      } else if (location.pathname === '/settings') {
        title = 'Settings';
      } else if (location.pathname === '/projects') {
        title = 'Projects';
      } else if (location.pathname === '/offers') {
        title = 'Offer List';
      } else if (pathToRegexp('/projects/:projectId').test(location.pathname)) {
        if (state.project.project) {
          title = `Project #${state.project.project.id} ${state.project.project.title}`;
        } else {
          title = 'Loading...';
        }
      } else if (pathToRegexp('/offers/:offerId').test(location.pathname)) {
        if (state.offer.offer) {
          title = `Offer #${state.offer.offer.id} ${state.offer.offer.name}`;
        } else {
          title = 'Loading...';
        }
      }

      if (title === null) {
        title = 'Kaizen Ad for Optimizer';
      } else {
        title = `${title} | Kaizen Ad for Optimizer`;
      }

      return <ReactDocumentTitle title={title} />;
    }}
  </StateConsumer>
);

export default DocumentTitle;
